import { useAlertStore } from '../../store/alertStore'
import { useSettingsStore } from '../../store/settingsStore'
import { ALL_HAZARD_TYPES, HAZARD_COLORS, HAZARD_LABELS, HAZARD_ICONS } from '../../types/cap'
import type { HazardType } from '../../types/cap'

export default function HazardFilter() {
  const { filters, toggleHazardType } = useAlertStore()
  const theme = useSettingsStore((s) => s.theme)
  const activeTypes = filters.hazard_types

  return (
    <div className="flex flex-wrap gap-1.5 px-3 py-2">
      {ALL_HAZARD_TYPES.map((hazard: HazardType) => {
        const active = activeTypes.length === 0 || activeTypes.includes(hazard)
        const color = HAZARD_COLORS[hazard]
        return (
          <button
            key={hazard}
            type="button"
            onClick={() => toggleHazardType(hazard)}
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border transition-all ${
              active
                ? 'opacity-100'
                : 'opacity-30 hover:opacity-60'
            }`}
            style={
              active
                ? { color, borderColor: color + '66', backgroundColor: color + '1a' }
                : theme === 'dark'
                  ? { color: '#6b7280', borderColor: '#374151', backgroundColor: 'transparent' }
                  : { color: '#6b7280', borderColor: '#d1d5db', backgroundColor: 'transparent' }
            }
            title={`${active ? 'Hide' : 'Show'} ${HAZARD_LABELS[hazard]}`}
          >
            <span>{HAZARD_ICONS[hazard]}</span>
            <span className="hidden sm:inline">{HAZARD_LABELS[hazard]}</span>
          </button>
        )
      })}
      {activeTypes.length > 0 && (
        <button
          type="button"
          onClick={() => useAlertStore.getState().setFilters({ hazard_types: [] })}
          className="text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 px-2 py-1 transition-colors"
        >
          Clear
        </button>
      )}
    </div>
  )
}
